// Telling a dead session apart from a refused operation.
//
// A write that fails because the access token expired mid-operation is
// recoverable: refresh and try again. A write refused on business grounds —
// not enough tokens, missing account, a row that is not yours — is not, and
// retrying it just runs it twice.
//
// Getting this wrong is expensive in one direction. A Chassis generation streams
// for up to fifteen minutes and is charged and stored only when it finishes, so
// misreading an expired token as a permanent failure discards work the API has
// already been billed for and the customer never sees.
//
// Deliberately narrow. `expired` alone is not enough to go on — a promo code, a
// subscription or a signed URL can all expire and say so, and none of those are
// fixed by refreshing the session. What PostgREST actually returns when the
// token is the problem is "JWT expired", a JWSError, or a 401.
const AUTH_ERROR = /\bjwt\b|\bjws|\b401\b|unauthori|unauthenti/i;

export function isAuthError(message: unknown): boolean {
  return AUTH_ERROR.test(String(message ?? ''));
}
